/**
 * The Equipes screen's blocked state (platform design §17.12, §4.5; Figma `329:12603`):
 * nothing is wrong, the campaign has simply never had a level. An `Analista` sees this
 * card with no action at all -- absent, not disabled (§17.15) -- since creating a level
 * is a write only `control_plane.write` may make; a writer instead sees `StructurePresets`,
 * the frame's template picker (ready-made hierarchies plus "Montar do zero").
 */
import { Share2 } from 'lucide-react';
import type { ReactNode } from 'react';

import { EmptyState } from '../../../chrome/state';
import { t } from '../i18n';
import { StructurePresets } from './StructurePresets';

export function NoStructure(props: {
  campaignId: string;
  canCreate: boolean;
  onCreateFirstLevel: () => void;
}): ReactNode {
  return (
    <EmptyState
      tone="blocked"
      icon={Share2}
      title={t('teams.blocked.title')}
      description={t('teams.blocked.description')}
      // The picker's rows run wider than a single button -- `EmptyContent`'s default
      // `max-w-sm` would wrap "Coordenação › Regional › Bairro › Comunidade" onto several
      // lines, which the frame never does.
      contentClassName={props.canCreate ? 'max-w-xl' : undefined}
      action={
        props.canCreate ? (
          <StructurePresets
            campaignId={props.campaignId}
            onBuildFromScratch={props.onCreateFirstLevel}
          />
        ) : undefined
      }
    />
  );
}
